/**
 * @param {String} titulo_original - Titulo original de la película o serie
 * @returns  {String} - Titulo de la película o serie con caracteres especiales removidos
 */
export const generateTitle = (titulo_original) => {
  // Replace non url friendly characters with their url friendly counterparts
  // and keep spaces

  return titulo_original
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-zA-Z0-9-] /g, '');
};

/**
 * @param {String} titulo_original - Titulo original de la película o serie
 *
 * @returns  {String} - url de la película o serie con caracteres especiales removidos y espacios reemplazados por _
 *
 * */

export const generateUrl = (titulo_original) => {
  return titulo_original
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/ /g, '_')
    .replace(/[^a-zA-Z0-9-]_/g, '')
    .toLowerCase();
};
